import { render } from "./FrameDetailsTab.vue?vue&type=template&id=28e5eb32&scoped=true"
import script from "./FrameDetailsTab.vue?vue&type=script&lang=js"
export * from "./FrameDetailsTab.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=28e5eb32&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e5eb32"]])

export default __exports__